import { connect } from 'react-redux';
import View from './AllPlanEditsCountView';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { setCurrentViewId } from '../WhatIfsActions';
import { numberOfEditsSelector } from '../AllPlanEdits/AllPlanEditsSelector';
import { isNumeric, createCustomPropType } from '../../../js/app/react/validators';
import { ALL_PLAN_EDITS } from '../WhatIfsConstants';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectedGoalId(state, ownProps),
  numberOfEdits: numberOfEditsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  setCurrentViewId: (clientId, goalId) => (event) => {
    event.stopPropagation();
    dispatch(setCurrentViewId(clientId, goalId, ALL_PLAN_EDITS));
  },
});

const AllPlanEditsCountContainer = connect(mapStateToProps, mapDispatchToProps)(View);

AllPlanEditsCountContainer.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default AllPlanEditsCountContainer;
